import { render, staticRenderFns } from "./Asistencia.vue?vue&type=template&id=1fdab154&"
import script from "./Asistencia.vue?vue&type=script&lang=js&"
export * from "./Asistencia.vue?vue&type=script&lang=js&"
import style0 from "./Asistencia.vue?vue&type=style&index=0&id=1fdab154&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports